import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 10h-4l3-8H7v11h3v9z"
}), 'FlashOnTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FlashOnTwoTone.js
// module id = 3728
// module chunks = 2